"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCSSVariables = void 0;
var tslib_1 = require("tslib");
var change_case_1 = require("change-case");
function toCSSVariables(input, prefix, initialColors) {
    if (prefix === void 0) { prefix = '--nfui'; }
    if (initialColors === void 0) { initialColors = {}; }
    return Object.keys(input).reduce(function (colors, name) {
        var _a;
        var value = input[name];
        var newPrefix = "".concat(prefix, "-").concat((0, change_case_1.paramCase)(name));
        if (typeof value === 'string') {
            return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, colors), (_a = {}, _a[newPrefix] = value, _a));
        }
        return toCSSVariables(value, newPrefix, colors);
    }, initialColors);
}
exports.toCSSVariables = toCSSVariables;
//# sourceMappingURL=css-variables.js.map